<template>
  <div>
    <button
      type="button"
      :class="[
        'btn btnclass smallerfontsize mr-3',
        genresSelected ? 'selected' : ''
      ]"
      @click="fieldData.showGenreModal = true"
    >
      Genre
    </button>
    <b-modal
      id="modal-genres"
      v-model="fieldData.showGenreModal"
      size="lg"
      title="Välj Genre"
      @shown="popupIsShown"
      @ok="saveGenres"
    >
      <b-tabs content-class="px-2">
        <GenrePickerGenre
          v-bind="$props"
          :genres-array="fieldData.genreOptionArray"
        />
      </b-tabs>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="cancel()"
        >
          Avbryt
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          @click="ok()"
        >
          Spara
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import GenrePickerGenre from "./GenrePickerGenre";

export default {
  name: "GenreModal",
  components: {
    GenrePickerGenre
  },
  props: ["field-data"],
  computed: {
    genresSelected(){
      this.$store.getters["searchApiBody/getPayload"].GenreConfigs
      let genres = JSON.parse(localStorage.getItem("genreConfigs")) || [];
      let areGenresSelected = genres.length > 0
      return areGenresSelected
    }
  },
  methods: {
    popupIsShown(){
      document.addEventListener("keyup", this.onKeyUp);
    },
    saveGenres() {
      let genreConfigs = this.$store.state.genres.genreConfigs;
      let payload = this.$store.getters["searchApiBody/getPayload"]
      payload.GenreConfigs = genreConfigs;
      this.$store.commit(
          'searchApiBody/updatePayload',
          payload,
        );
      localStorage.genreConfigs = JSON.stringify(genreConfigs);
    }, 
    popupIsHidden(){
      document.removeEventListener("keyup", this.onKeyUp);
    },
    onKeyUp(event) {
      if (event.key === "Enter" && this.fieldData.showGenreModal) {
        this.fieldData.showGenreModal = false;
        this.saveGenres()
      }
    },
  }
};
</script>
<style scoped>
label {
  width: 100%;
}
</style>
